import React, { Component } from 'react';

import { MenuItem, Select, withStyles } from '@material-ui/core';
import { AxlSimpleDropDown } from 'axl-reactjs-ui';
import { saveAs } from "file-saver";
import { get, identity, map, pickBy } from 'lodash';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { withRouter, } from 'react-router-dom';
import AxlDateInput from '../../components/AxlDateInput';
import StyledAxlMultiSelect from '../../components/StyledAxlMultiSelect';
import Button from '../../components/JMuiButton';
import GetAppIcon from '@material-ui/icons/GetApp';

// Styles
import styles, { Container, Flex, GroupField, Label, newStyles } from './styles';
@inject('deliveryStore', 'userStore')
@observer
class DispatchSearchFilter extends Component {
  constructor(props) {
      super(props);
      const { day, region } = this.props.match.params;
      const { deliveryStore } = this.props;
      this.setDate = this.setDate.bind(this);

      if (day) {
          if (day === 'today') {
              deliveryStore.start = new Date().getTime();
          } else {
              deliveryStore.start = moment(day).startOf('day').unix();
          }
      }
      if (region && region !== 'all') {
          deliveryStore.regions = region.toUpperCase().split(',');
      }

  }

  componentDidMount() {
      const { deliveryStore } = this.props;
      const { day, region } = this.props.match.params;
      const url = new URL(window.location.href);
      const stores = url.searchParams.get("stores");
      const brands = url.searchParams.get("brands");
      const services = url.searchParams.get("services");
      if (stores) {
        deliveryStore.stores = stores.trim().split(',').map(s => parseInt(s));
      } else {
        deliveryStore.stores = [];
      }

      if (brands) {
        deliveryStore.profiles = brands.trim().split(',').map(s => parseInt(s));
      } else {
        deliveryStore.profiles = [];
      }

      if (services) {
        deliveryStore.service_levels = services.trim().split(',');
      } else {
        deliveryStore.service_levels = [];
      }

      if(!region){
        deliveryStore.regions = [];
      }

      if(!day){
        const date = new Date();
        date.setHours(0, 0, 0, 0 );
        deliveryStore.start = date.getTime() / 1000;
      }

      deliveryStore.sortBy = '-id';

      deliveryStore.loadWarehouses();
      deliveryStore.loadShipments();
      deliveryStore.loadRegions();
  }

  setDate(d) {
      const { deliveryStore, history } = this.props;
      this.handleQueryParams(d, 'day')
      if(d) {
        deliveryStore.setDate(d);
      } else {
        history.push(`/deliveries`);
        const date = new Date();
        date.setHours(0, 0, 0, 0 );
        deliveryStore.setDate(date.getTime());
      }
  }

  setRegions(regions) {
    const { deliveryStore } = this.props;
    deliveryStore.setRegions(regions.map(r => r.value));
    this.handleQueryParams(regions.map(s => s.value), 'stores')
  }

  setStores = (stores) => {
    const { deliveryStore } = this.props;
    deliveryStore.setStores(stores.map(s => s.value));
    this.handleQueryParams(stores.map(s => s.value), 'stores')
  };

  setBrands = (brands) => {
    const { deliveryStore } = this.props;
    deliveryStore.setProfiles(brands.map(s => s.value));
    this.handleQueryParams(brands.map(s => s.value), 'brands')
  }

  setServiceLevel = (services) => {
    const { deliveryStore } = this.props;
    deliveryStore.setSerivceLevels(services.map(s => s.value));
    this.handleQueryParams(services.map(s => s.value), 'service_levels');
  }

  handleQueryParams = (data, type) => {
    const { deliveryStore, history, userStore } = this.props;
    const { enableStoreFilter, start, regions, stores, profiles, service_levels} = deliveryStore;
    const { isBrandsOwner, clientSettings } = userStore;
    const isExistServiceLevel = !!get(clientSettings, 'settings.service_filters');

    let dayStr = moment(start * 1000).format('YYYY-MM-DD');
    let regionStr = regions?.length > 0 ? regions?.join(",") : 'all';
    let storeStr = stores?.join(",") || '';
    let brandStr = profiles?.join(",") || '';
    let serviceStr = service_levels?.join(",") || '';

    switch (type) {
      case 'day': 
        dayStr = moment(data).format('YYYY-MM-DD');
        break;
      case 'regions':
        regionStr = data?.join(",");
        break;
      case 'stores':
        storeStr = data?.join(",");
        break;
      case 'brands':
        brandStr = data?.join(",");
        break;
      case 'service_levels':
        serviceStr = data?.join(",");
        break;
    }

    const queryObj = {
      stores: enableStoreFilter ? storeStr : '',
      brands: isBrandsOwner ? brandStr : '',
      services: isExistServiceLevel ? serviceStr : '',
    } 

    history.push(`/deliveries/${dayStr}/${regionStr}?${new URLSearchParams(pickBy(queryObj, identity)).toString()}`);
  }

  downloadCSV = (e) => {
    const {deliveryStore} = this.props;
    const {start, regions} = deliveryStore;


    let filename = moment(start * 1000).format("YYYY-MM-DD");

    if (regions && regions.length > 0) {
      filename += "-" + regions.join("-");
    }

    filename += "-shipments.csv";
    deliveryStore.downloadCsv('/shipments/by-date/csv', (data) => {
      const blob = new Blob([data.csv], {type: "text/plain;charset=utf-8"});
      saveAs(blob, filename);
    })
  };

  downloadExceptionReport(type) {
    const { deliveryStore } = this.props;
    const { start } = deliveryStore;
    const filename = `--${moment(start * 1000).format("YYYY-MM-DD")}-${type === 'inbound' ? 'inbound-exception-report' : 'outbound-exception-report'}.csv`;

    deliveryStore.downloadCsv(`${import.meta.env.REACT_APP_API_ROOT}/shipments/by-date/exception-report/${type}`, (data) => {
      const blob = new Blob([data.csv], { type: "text/plain;charset=utf-8" });
      saveAs(blob, filename);
    })
  }

  pingLabel = (request, filename) => {
    const {deliveryStore} = this.props;
    deliveryStore.pingRequestLabelShipments(request, (respRequest) => {
      if (respRequest.shipment_size === 0) {
        deliveryStore.labelingShipments = false;
      } else if (respRequest.pdf_url) {
        this.downloadUrl(respRequest.pdf_url, filename);
        // window.location.href = respRequest.pdf_url;
        deliveryStore.labelingShipments = false;
      } 
      else {
        setTimeout(() => this.pingLabel(request, filename), 1000);
      }
    })
  };

  downloadUrl = (URLToPDF, filename) => {
    var oReq = new XMLHttpRequest();
    // The Endpoint of your server
    // Configure XMLHttpRequest
    oReq.open("GET", URLToPDF, true);

    // Important to use the blob response type
    oReq.responseType = "blob";

    // When the file request finishes
    // Is up to you, the configuration for error events etc.
    oReq.onload = function() {
        // Once the file is downloaded, open a new window with the PDF
        // Remember to allow the POP-UPS in your browser
        var file = new Blob([oReq.response]);

        // Generate file download directly in the browser !
        saveAs(file, filename);
    };

    oReq.send();
  };


  downloadUrl1 = (url, filename) => {
    var element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('target', "_blank");
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };

  downloadLabel = (order) => {
    const {deliveryStore} = this.props;
    const {start, regions} = deliveryStore;


    let filename = moment(start * 1000).format("YYYY-MM-DD");

    if (regions && regions.length > 0) {
      filename += "-" + regions.join("-");
    }

    filename += "-label.pdf";
    deliveryStore.requestLabelShipments(order, (data) => {
      console.log('got data is: ', data)
      this.pingLabel(data, filename);
    })
  };

  render() {
    const { deliveryStore, userStore, classes } = this.props
    const sortOptions = [      
      {name: 'ID', value: 'id'},
      {name: 'ID DESC', value: '-id'},            
      {name: 'Internal ID', value: '-internal_id'},
    ];

    const downloadItems = [
      {title: 'Outbound Exception Report', action: () => this.downloadExceptionReport('outbound')},
      {title: 'Inbound Exception Report', action: () => this.downloadExceptionReport('inbound')}
    ];

    const downloadPDFs = [
      {title: 'Sort default', action: () => this.downloadLabel()},
      {title: 'Sort by label', action: () => this.downloadLabel("label")},
      {title: 'Sort by label DESC', action: () => this.downloadLabel("-label")},
      {title: 'Sort by order ID', action: () => this.downloadLabel("internal_id")},
      {title: 'Sort by order ID DESC', action: () => this.downloadLabel("-internal_id")},
      {title: 'Sort by Service Level', action: () => this.downloadLabel("service_level,client_internal_shipment_id")}
    ];

    const { sortBy, enableStoreFilter, warehouses, stores, profiles, regions, shipments, labelingShipments, regionList, service_levels } = deliveryStore;
    const { isBrandsOwner, clientProfileOptions, clientSettings } = userStore;
    const serviceLevels = map(get(clientSettings, 'settings.service_filters')?.split(","), item => ({
      value: item,
      label: item.replaceAll("_", " ")
    }));


    const { day, region } = this.props.match.params;

    return (
      <Container className="no-bold" style={{ alignItems: 'center' }}>
        <Flex>
          <GroupField>
            <Label>{`Overview for `}</Label>
            <AxlDateInput
              arrow
              clear="true"
              onChange = { (d) => this.setDate(d) }
              options={{
                // maxDate: 'today',
                defaultValue: day ? deliveryStore.start * 1000 : new Date().getTime(),
                defaultDate: 'today',
                dateFormat: 'MMM DD, Y',
                placeHolder: 'today',
                enableTime: false,
                altInput: false,
                clickOpens: false,
                altInputClass: 'form-conrol'
              }}
            />
          </GroupField>
          <GroupField>
            <Label>{`in`}</Label>
            <StyledAxlMultiSelect
              defaulValue={region && regionList.filter(option => regions.indexOf(option.value) >= 0)}
              placeholderButtonLabel="all regions"
              showValues={false}
              allowAll={true}
              onChange={(v) => this.setRegions(v)}
              placeholder="Search Regions…"
              options={regionList}
            />
          </GroupField>
          {enableStoreFilter && (
            <GroupField>
              <Label>{`of`}</Label>
              <StyledAxlMultiSelect
                defaulValue={warehouses.filter(option => stores.includes(option.value))}
                placeholderButtonLabel="all stores"
                showValues={false}
                allowAll={true}
                onChange={(v) => this.setStores(v)}
                placeholder="Search stores…"
                options={warehouses}
              />
            </GroupField>
          )}
          {isBrandsOwner && (
            <GroupField>
              <Label>{`of`}</Label>
              <StyledAxlMultiSelect
                defaulValue={clientProfileOptions.filter(option => profiles.includes(option.value))}
                placeholderButtonLabel="all brands"
                showValues={false}
                allowAll={true}
                onChange={(v) => this.setBrands(v)}
                placeholder="Search brands…"
                options={clientProfileOptions}
              />
            </GroupField>
          )}
          {serviceLevels?.length > 0 && (
            <GroupField>
              <Label>{`for`}</Label>
              <StyledAxlMultiSelect
                defaulValue={serviceLevels.filter(option => service_levels.includes(option.value))}
                placeholderButtonLabel="all service levels"
                showValues={false}
                allowAll={true}
                onChange={(v) => this.setServiceLevel(v)}
                placeholder="Search service level…"
                options={serviceLevels}
              />
          </GroupField>
          )}
          <GroupField>
            <Label>{`sort`}</Label>
            <Select value={sortBy}
                    className={classes.select}
                    onChange={(e) => deliveryStore.setSortBy(e.target.value)}
                    inputProps={{className: classes.selectInput}}
            >
              {sortOptions.map(opt => <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>)}
            </Select>
          </GroupField>
        </Flex>

        <Button size="small" onClick={this.downloadCSV} variant="contained" color="primary" startIcon={<GetAppIcon />}>
          CSV
        </Button>

        {(shipments && shipments.length > 0) && (
          <AxlSimpleDropDown anchor={'right'} style={{ zIndex: 10000, width: '200px' }} items={downloadPDFs}>
            <Button size="small" onClick={this.downloadPDF} variant="contained" color="secondary" loading={labelingShipments} disabled={labelingShipments} startIcon={<GetAppIcon />} style={{marginLeft: 4}}>
              PDF
            </Button>
          </AxlSimpleDropDown>
        )}

        <AxlSimpleDropDown anchor={'right'} style={{zIndex: 10000, width: '200px'}} items={downloadItems}>
          <i style={{fontSize: 22, color: '#828282', cursor: 'pointer', margin: '0 3px'}} className={'fa fa-download'} />
        </AxlSimpleDropDown>
      </Container>
    )
  }
}

export default withStyles(newStyles)(withRouter(DispatchSearchFilter));
